type UpdateButtonState = () => void;

export function occupancyInput(): void {
  function onDocumentReady(): void {
    const containers: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.cmp-occupancy-counter-form'
    );

    containers.forEach((container: HTMLElement) => {
      const formText: HTMLElement | null = container.querySelector('.cmp-form-text');
      if (!formText) return;

      const input: HTMLInputElement | null = formText.querySelector('input[type="number"]');
      if (!input) return;
      const minValue: number = input.getAttribute('min') ? parseInt(input.min) : 1;
      console.log('INPUT ', input, minValue);
      const updateButtonState: UpdateButtonState = (): void => {
        const currentValue: number = parseInt(input.value);

        if (input.value === '') {
          formText.classList.add('minus-disabled');
          formText.classList.remove('plus-disabled');
          return;
        }

        if (isNaN(currentValue) || currentValue < minValue) {
          input.value = minValue.toString();
        }

        formText.classList.toggle('minus-disabled', currentValue <= minValue);

        const currentValueMax: number | null = parseInt(input.getAttribute('max') ?? '') || null;
        if (currentValueMax !== null) {
          formText.classList.toggle('plus-disabled', currentValue >= currentValueMax);
        } else {
          formText.classList.remove('plus-disabled');
        }

        if (currentValueMax && currentValue > currentValueMax) {
          input.value = currentValueMax.toString();
        }
      };

      updateButtonState();

      if (formText.classList.contains('occupancy-initialized')) return;

      formText.classList.add('occupancy-initialized');
      formText.addEventListener('click', (event: MouseEvent) => {
        const currentValue: number = isNaN(parseInt(input.value))
          ? minValue
          : parseInt(input.value);
        const currentValueMax: number | null = parseInt(input.getAttribute('max') ?? '') || null;
        const target = event.currentTarget as HTMLElement;
        const afterStyle = getComputedStyle(target, ':after');
        const beforeStyle = getComputedStyle(target, ':before');
        const formTextRect = target.getBoundingClientRect();
        const inputRect = input.getBoundingClientRect();

        // Get dimensions from computed style
        const afterWidth = parseFloat(afterStyle.getPropertyValue('width'));
        const beforeWidth = parseFloat(beforeStyle.getPropertyValue('width'));
        const pseudoHeight = parseFloat(afterStyle.getPropertyValue('height'));

        // Calculate positions
        const afterLeft = inputRect.right;
        const beforeLeft = inputRect.left - beforeWidth;
        const pseudoTop = formTextRect.top + (formTextRect.height - pseudoHeight) / 2;

        const { clientX, clientY } = event;

        if (
          clientX >= afterLeft &&
          clientX <= afterLeft + afterWidth &&
          clientY >= pseudoTop &&
          clientY <= pseudoTop + pseudoHeight
        ) {
          if (currentValueMax) {
            if (currentValue < currentValueMax) {
              input.value = (currentValue + 1).toString();
              updateButtonState();
            }
          } else {
            input.value = (currentValue + 1).toString();
            updateButtonState();
          }
        } else if (
          clientX >= beforeLeft &&
          clientX <= beforeLeft + beforeWidth &&
          clientY >= pseudoTop &&
          clientY <= pseudoTop + pseudoHeight
        ) {
          if (currentValue > minValue) {
            input.value = (currentValue - 1).toString();
            updateButtonState();
          }
        }
      });

      input.addEventListener('input', updateButtonState);

      input.addEventListener('blur', () => {
        if (input.value === '') {
          input.value = minValue.toString();
          updateButtonState();
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

occupancyInput();
